import { motion } from "framer-motion";
import { LINKS } from "@/lib/constants";

export default function BookingCTA() {
  return (
    <motion.section
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8 }}
      className="py-24 lg:py-32"
      style={{ background: "linear-gradient(135deg, #C9A84C, #E8CC7A 50%, #C9A84C)" }}
      data-testid="booking-section"
    >
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl" style={{ color: "#080808" }} data-testid="booking-headline">
          Bereit für deinen neuen Look?
        </h2>
        <p className="mt-6 text-base md:text-lg" style={{ color: "rgba(8,8,8,0.75)" }}>
          Buche deinen Termin direkt online — in 60 Sekunden, ohne Wartezeit.
        </p>
        <div className="mt-10">
          <a href={LINKS.fresha} target="_blank" rel="noopener noreferrer" className="btn-black" data-testid="booking-fresha-cta">
            Jetzt Termin buchen via Fresha
          </a>
        </div>
        <p className="mt-6 text-sm" style={{ color: "rgba(8,8,8,0.6)" }}>
          Oder ruf uns direkt an — Nummer auf{" "}
          <a href={LINKS.maps} target="_blank" rel="noopener noreferrer" className="underline font-medium" style={{ color: "#080808" }} data-testid="booking-maps-link">
            Google Maps
          </a>
        </p>
      </div>
    </motion.section>
  );
}
